import { ComponentType } from '@angular/cdk/portal';
import { Injectable } from '@angular/core';
import { WindowService } from 'src/app/shared/components/window/window.service';
import { SimulationQuery } from 'src/app/simulation/state/simulation.query';
import { MapAction } from '../map-action';
import { FeatureSelectionService } from './feature-selection.service';

@Injectable({
  providedIn: 'root'
})
export class FeatureOpenService extends MapAction {

  private mapbox: mapboxgl.Map;

  private disabled: boolean;
  private selected: mapboxgl.MapboxGeoJSONFeature;
  private hoverCount = 0;

  constructor(
    private windowService: WindowService,
    private featureSelectionService: FeatureSelectionService,
    simulationQuery: SimulationQuery,
  ) {
    super();

    simulationQuery.active$.subscribe(s => this.disabled = !!s);
  }

  listen(mapbox: mapboxgl.Map, config: OpenWindowConfig) {
    this.mapbox = mapbox;

    this.listenSelection();
    this.listenHover(config.layerName);
    this.listenClick(config);
  }

  private listenSelection() {

    this.featureSelectionService.selecteds$.subscribe(featuresMap => {

      if (featuresMap.size === 1) {
        const feature = Array.from(featuresMap.values())[0] as mapboxgl.MapboxGeoJSONFeature;
        this.selected = feature;
        return;
      }

      this.selected = null;
    });
  }

  private listenClick(config: OpenWindowConfig) {
    this.mapbox.on('click', config.layerName, (e) => {

      if (this.ignored(e)) {
        return;
      }

      if (this.active && !e.defaultPrevented) {
        this.openWindow(config, e.features[0].properties);
        e.preventDefault();
        e.originalEvent.preventDefault();
      }
    });
  }

  private listenHover(layerName: string) {
    let feature: mapboxgl.MapboxGeoJSONFeature;


    this.mapbox.on('mouseenter', layerName, (e) => {

      if (this.ignored(e)) {
        return;
      }

      this.mapbox.getCanvas().style.cursor = 'pointer';

      feature = e.features[0];
      this.mapbox.setFeatureState(feature, { m_hover: true });
      this.hoverCount++;
    });

    this.mapbox.on('mouseleave', layerName, (e) => {
      if (!feature) {
        return;
      }

      this.mapbox.setFeatureState(feature, { m_hover: false });
      this.hoverCount--;

      if (this.hoverCount === 0) {
        this.mapbox.getCanvas().style.cursor = '';
      }
    });
  }

  private ignored(e: MouveEvent) {
    return this.disabled || e.originalEvent.ctrlKey || this.selected;
  }

  private openWindow(config: OpenWindowConfig, properties: object) {

    this.windowService.open({
      title: config.title,
      componentType: config.componentType,
      config: { data: properties }
    });
  }

}

export interface OpenWindowConfig {
  title: string;
  layerName: string;
  componentType: ComponentType<any>;
}

type MouveEvent = mapboxgl.MapMouseEvent & {
  features?: mapboxgl.MapboxGeoJSONFeature[];
} & mapboxgl.EventData;

